import { z } from 'zod';
import { longText, name, uuid } from './fields';
import { MasterList } from './master-lists';

/**
 * Activities — "what are we doing?" prompts bundling Master Lists (data-model.md
 * §6, api-contract §4). A selection shortcut, NOT a container the items live in.
 * Owner-scoped in Phase 1.
 */

/** Bare Activity resource (response shape — api-contract §4, list/create/update). */
export const Activity = z.object({
  id: uuid(),
  ownerId: uuid(),
  name: name(),
  prompt: longText(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});
export type Activity = z.infer<typeof Activity>;

/**
 * Expanded Activity returned by the single-GET (api-contract §4.3). Bundled
 * lists are full `MasterList` objects (not ids) so the guided pull-in UI can
 * show what each Activity bundles without an N+1, in attach order.
 */
export const ActivityWithLists = Activity.extend({
  masterLists: z.array(MasterList),
});
export type ActivityWithLists = z.infer<typeof ActivityWithLists>;

/** POST body (api-contract §4.2). Server sets `ownerId`, timestamps. */
export const CreateActivityInput = z.object({
  name: name(),
  prompt: longText().optional(),
});
export type CreateActivityInput = z.infer<typeof CreateActivityInput>;

/** PATCH body (api-contract §4.4) — all optional. */
export const UpdateActivityInput = z
  .object({
    name: name(),
    prompt: longText(),
  })
  .partial();
export type UpdateActivityInput = z.infer<typeof UpdateActivityInput>;

/** POST /:activityId/lists body — attach a Master List (api-contract §4.6). */
export const AttachActivityListInput = z.object({
  masterListId: uuid(),
});
export type AttachActivityListInput = z.infer<typeof AttachActivityListInput>;
